/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FileCompressUpload from './CustomFormList/FileCompressUpload';
import Loading from "vux/src/components/loading/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Previewer from "vux/src/components/previewer/index.vue";
import { baseUrl, target1, target2 } from '@root/_target.js';
export default {
  name: 'ImgUploadInput',
  components: {
    Previewer: Previewer,
    FileCompressUpload: FileCompressUpload,
    Loading: Loading
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    title: {
      type: String,
      default: '图片'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    num: {
      type: Number,
      default: 9
    },
    hiddenBorder: {
      type: Boolean,
      default: false
    },
    onlyCamera: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '/upload/h5/save'
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false,
      loadingShow: false,
      progress: 0
    };
  },
  computed: {
    oss: function oss() {
      return false; // return process.env.NODE_ENV !== 'development'
    },
    imgUrlsForPreviewer: function imgUrlsForPreviewer() {
      return this.currValue.map(function (item) {
        return {
          src: item
        };
      });
    },
    isUpperLimit: function isUpperLimit() {
      return this.currValue.length === this.num;
    },
    realtarget: function realtarget() {
      return target2 + this.target;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    start: function start(e) {
      this.loadingShow = true;
    },
    finish: function finish(e) {
      this.loadingShow = false;

      if (e.currentTarget.status === 200) {
        var res = JSON.parse(e.currentTarget.response);
        console.log(res);

        if (res) {
          if (res.success) {
            res.url = res.data.fileUrl + res.data.files;
            this.currValue = this.currValue.concat([{
              file_type: 1,
              file_url: res.url
            }]);
          } else {
            this.$vux.toast.text(res.message);
          }
        } else {
          this.$vux.toast.text('上传出错，请重试。。。');
        }
      } else {
        this.$vux.toast.text(e.currentTarget.statusText);
      }
    },
    clickUpload: function clickUpload() {
      if (this.currValue.length === this.num) {
        this.$vux.toast.text("\u56FE\u7247\u6700\u591A".concat(this.num, "\u5F20"));
      }
    },
    deleteImg: function deleteImg(index) {
      this.currValue.splice(index, 1);
    },
    show: function show(index) {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['previewer'].show(index);
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};